module.exports = __webpack_public_path__ + "img/cashapp-icon.8cd46e8d.svg";